import React from 'react';
import 'components/Vote/vote.css';
import {Box} from "@mui/material";

const LoadingPlaceholderBlock = (props) => {

    const {width, height, borderRadius, backgroundColor} = props;

    return(
        <div className='overflow-hidden'>
            <Box
                sx={{
                    width,
                    height,
                    borderRadius,
                    backgroundColor: backgroundColor || '#eae9e9',
                }}
                className='loading'/>
        </div>
    )
};

export default LoadingPlaceholderBlock